export default __webpack_public_path__ + "static/media/check.d123d054.svg";